import { useState } from "react";
import { usePolling } from "@/hooks/polling/use-polling";
import { POLLING_INTERVALS } from "@/hooks/polling/polling-intervals";

interface CreatePrintHouseTestPayload {
  domain?: string;
  username?: string;
  password?: string;
}
interface CreatePrintHouseTestPayloadData {
  data?: string;
}
const useCreatePrintHouseTestSocketIo = () => {
  const [data, setData] = useState<CreatePrintHouseTestPayload | null>(null);

  usePolling({
    intervalMs: POLLING_INTERVALS.createPrintHouseTest,
    events: {
      createPrintHouseTest: (payload) => {
        const typedPayload = payload as CreatePrintHouseTestPayloadData;
        const jsonString = JSON.parse(typedPayload.data);
        setData(jsonString || null);
      },
    },
  });

  return { data };
};

export { useCreatePrintHouseTestSocketIo };
